/**
 * Conversation companion stack commands over `lib/focus/focus-plan-companion.ts`.
 */
import { usePresentationStore } from "@/stores/presentation-store";
import type { FocusWindowBox } from "@/lib/focus-window-layout";
import { commitPresentation } from "@/lib/focus/focus-adapter";
import { currentFocusPlanEnv } from "@/lib/focus/focus-natural-size";
import {
  planExpandCompanionFrame,
  planRememberCompanionBox,
  planRemoveCompanionFrame,
} from "@/lib/focus/focus-plan-companion";
import type { PresentationState } from "@/lib/focus/focus-types";
export { calculateConversationCompanionFocusLayout } from "@/lib/conversation-companion-focus-geometry";

function commitCompanionChange(next: PresentationState | null): boolean {
  if (!next) return false;
  commitPresentation(next);
  return true;
}

export function expandConversationCompanionStackFrame(
  frameId: string,
): boolean {
  return commitCompanionChange(
    planExpandCompanionFrame(
      usePresentationStore.getState().presentation,
      frameId,
      currentFocusPlanEnv(),
    ),
  );
}

/** Keep the box a user gesture left an artifact in; the renderer shows it. */
export function rememberConversationCompanionFrameBox(
  frameId: string,
  box: FocusWindowBox | null,
): boolean {
  const next =
    box &&
    planRememberCompanionBox(
      usePresentationStore.getState().presentation,
      frameId,
      box,
      currentFocusPlanEnv(),
    );
  if (!next) return false;
  usePresentationStore.setState({ presentation: next });
  return true;
}

export function removeConversationCompanionFocusFrame(
  frameId: string,
): boolean {
  return commitCompanionChange(
    planRemoveCompanionFrame(
      usePresentationStore.getState().presentation,
      frameId,
      currentFocusPlanEnv(),
    ),
  );
}
